export default __webpack_public_path__ + "static/media/designerIcon.20d57c6d.png";